import React from 'react'

export default function Recommendations({ recommendations, explanation }) {
  return (
    <>
      {explanation && (
        <div className="card">
          <div className="card__title">Assessment Narrative</div>
          <p style={{ fontSize: 12, lineHeight: 1.7, color: 'var(--color-muted)' }}>
            {explanation}
          </p>
        </div>
      )}
      {recommendations?.length > 0 && (
        <div className="card">
          <div className="card__title">Recommendations</div>
          <ul className="rec-list">
            {recommendations.map((r, i) => (
              <li key={i}>{r}</li>
            ))}
          </ul>
        </div>
      )}
    </>
  )
}
